import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { HttpEventLoaderComponent } from '@shared/component';
import { TvaPermissionDirective } from '@shared/directive/permission.directive';

import { HeaderComponent } from './header/header.component';
import { MainComponent } from './main/main.component';

const sideNavCollapsedKey = 'isSideNavCollapsed';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [
    HeaderComponent,
    MainComponent,
    RouterOutlet,
    HttpEventLoaderComponent,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    TvaPermissionDirective,
    MatTooltipModule,
    MatButtonModule,
  ],
})
export class LayoutComponent implements OnInit {
  isSideNavCollapsed = false;

  ngOnInit(): void {
    const isSidenavCollapsed = JSON.parse(localStorage.getItem(sideNavCollapsedKey) || 'false');

    if (isSidenavCollapsed) {
      this.isSideNavCollapsed = true;
    }
  }

  toggleSideNav() {
    this.isSideNavCollapsed = !this.isSideNavCollapsed;
    localStorage.setItem(sideNavCollapsedKey, JSON.stringify(this.isSideNavCollapsed));
  }
}
